/**
 * @module components/LoadingSpinner
 * @description CSS-based loading spinner component with ripple animation.
 * Pure CSS animation without external dependencies for lightweight loading indication.
 */

import React from 'react';

/**
 * @typedef LoadingSpinnerProps
 * @property {Record<string, unknown>} [props] - Component props (unused)
 */

/**
 * @component LoadingSpinner
 * @type {React.FC<LoadingSpinnerProps>}
 * @summary Animated ripple loading spinner implemented with inline CSS.
 * Shows expanding concentric circles for loading states.
 * @param {LoadingSpinnerProps} props - Component props (unused)
 * @returns {React.ReactElement} Spinner with inline animation styles
 */
function LoadingSpinner(props) {
  return (
    <>
      <style
        dangerouslySetInnerHTML={{
          __html: `
        .lds-ripple {
          display: inline-block;
          position: relative;
          width: 80px;
          height: 80px;
          transform: rotate(-45deg);
        }
        .lds-ripple div {
          position: absolute;
          border: 4px solid #fff;
          opacity: 1;
          border-radius: 50%;
          animation: lds-ripple 1s cubic-bezier(0, 0.2, 0.8, 1) infinite;
        }
        .lds-ripple div:nth-child(2) {
          animation-delay: -0.5s;
        }
        @keyframes lds-ripple {
          0% {
            top: 36px;
            left: 36px;
            width: 0;
            height: 0;
            opacity: 1;
          }
          100% {
            top: 0px;
            left: 0px;
            width: 72px;
            height: 72px;
            opacity: 0;
          }
        }
      `,
        }}
      ></style>
      <div className="lds-ripple">
        <div></div>
        <div></div>
      </div>
    </>
  );
}

export default LoadingSpinner;
